import { AdSlotFormatEnum } from './dto/recs.dto';

export const API_URL = process.env.API_URL;
export const APP_VERSION = process.env.APP_VERSION;
export const MEDIA_BASE_URL = process.env.MEDIA_BASE_URL;
export const DEFAULT_DATASET_ID = 'revops-suggestions';
export const APP_DEBUG = process.env.APP_DEBUG;

export const DEFAULT_LINK_REFERRER_POLICY = 'strict-origin-when-cross-origin, no-referrer-when-downgrade';
export const DEFAULT_LINK_INTERNAL_REL = '';
export const DEFAULT_LINK_EXTERNAL_REL = 'sponsored';
export const DEFAULT_LINK_INTERNAL_TARGET = '_self';
export const DEFAULT_LINK_EXTERNAL_TARGET = '_blank';

export const AdSlotFormatSizeMap: Record<AdSlotFormatEnum, { width: number | 'auto', height: number | 'auto' }> = {
  [ AdSlotFormatEnum.AUTO ]: { width: 'auto', height: 'auto' },
  [ AdSlotFormatEnum.LEADERBOARD ]: { width: 728, height: 90 },
  [ AdSlotFormatEnum.LARGE_LEADERBOARD ]: { width: 840, height: 150 },
  [ AdSlotFormatEnum.XL_LEADERBOARD ]: { width: 995, height: 123 },
  [ AdSlotFormatEnum.TV_SPOT_LEADERBOARD ]: { width: 840, height: 250 },
  [ AdSlotFormatEnum.BILLBOARD ]: { width: 970, height: 250 },
  [ AdSlotFormatEnum.WIDE_SKYSCRAPER ]: { width: 160, height: 600 },
  [ AdSlotFormatEnum.SKYSCRAPER ]: { width: 120, height: 600 },
  [ AdSlotFormatEnum.HALF_PAGE_SKYSCRAPER ]: { width: 300, height: 600 },
  [ AdSlotFormatEnum.MEDIUM_RECTANGLE ]: { width: 300, height: 250 },
  [ AdSlotFormatEnum.SQUARE_RECTANGLE ]: { width: 250, height: 250 },
  [ AdSlotFormatEnum.HALF_PAGE_RECTANGLE ]: { width: 300, height: 600 },
  [ AdSlotFormatEnum.XL_RECTANGLE ]: { width: 468, height: 400 },
  [ AdSlotFormatEnum.MEDIUM_SPLASH ]: { width: 640, height: 480 },
  [ AdSlotFormatEnum.SMALL_SPLASH ]: { width: 500, height: 400 },
  [ AdSlotFormatEnum.SMARTPHONE_BANNER ]: { width: 320, height: 50 },
  [ AdSlotFormatEnum.SUPER_LEADERBOARD ]: { width: 970, height: 90 },
  [ AdSlotFormatEnum.PORTRAIT ]: { width: 300, height: 1050 },
  [ AdSlotFormatEnum.MOBILEPHONEINTERSTITIAL1 ]: { width: 640, height: 1136 },
  [ AdSlotFormatEnum.MOBILEPHONEINTERSTITIAL2 ]: { width: 750, height: 1334 },
  [ AdSlotFormatEnum.MOBILEPHONEINTERSTITIAL3 ]: { width: 1080, height: 1920 },
  [ AdSlotFormatEnum.FEATURE_PHONE_SMALL_BANNER ]: { width: 120, height: 20 },
  [ AdSlotFormatEnum.FEATURE_PHONE_MEDIUM_BANNER ]: { width:168, height: 28 },
  [ AdSlotFormatEnum.FEATURE_PHONE_LARGE_BANNER ]: { width: 216, height: 36 },
};
